import { CurrencyCircleDollarIcon as PhosphorCurrencyCircleDollarIcon } from "@phosphor-icons/react/dist/ssr/CurrencyCircleDollar";

import { createAppIcon } from "@/components/createAppIcon";

export const PaidIcon = /* @__PURE__ */ createAppIcon(PhosphorCurrencyCircleDollarIcon);
export const PaidFilledIcon = /* @__PURE__ */ createAppIcon(
  PhosphorCurrencyCircleDollarIcon,
  "fill",
);
